export type GeoPoint = { lat: number; lng: number };

export const ARRIVAL_RADIUS_METERS =
  Number(import.meta.env.VITE_ARRIVAL_RADIUS_METERS) || 200;

export const ARRIVAL_MIN_ACCURACY_METERS = 100;

export const ARRIVAL_CONSECUTIVE_READINGS = 2;

const EARTH_RADIUS_METERS = 6_371_000;

function toRadians(degrees: number): number {
  return (degrees * Math.PI) / 180;
}

/** Haversine distance between two WGS84 points in meters. */
export function getDistanceMeters(a: GeoPoint, b: GeoPoint): number {
  const dLat = toRadians(b.lat - a.lat);
  const dLng = toRadians(b.lng - a.lng);
  const lat1 = toRadians(a.lat);
  const lat2 = toRadians(b.lat);

  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;

  return 2 * EARTH_RADIUS_METERS * Math.asin(Math.sqrt(h));
}

export function isWithinRadiusMeters(
  worker: GeoPoint,
  destination: GeoPoint,
  radiusMeters: number = ARRIVAL_RADIUS_METERS
): boolean {
  return getDistanceMeters(worker, destination) <= radiusMeters;
}

/** GeoJSON Point coordinates are [lng, lat]. */
export function geoJsonToPoint(coordinates?: [number, number] | null): GeoPoint | null {
  if (!coordinates || coordinates.length < 2) return null;
  const [lng, lat] = coordinates;
  if (typeof lat !== 'number' || typeof lng !== 'number') return null;
  return { lat, lng };
}

export function formatDistanceMeters(meters: number): string {
  if (meters < 1000) return `${Math.round(meters)}m`;
  return `${(meters / 1000).toFixed(1)}km`;
}
